import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { PRIVACY_PERMISSIONS, PIXLEE_KEY, PIXLEE_SCRIPT_ID, PIXLEE_SCRIPT_SRC } from '@/constants';
import createScript from '@/utils/create-script';
import makeQueryKey from '@/api/utils/make-query-key';

const getPermissions = () => {
  const permissionsArray = window?.NikePrivacy?.permissions.get() || [];
  return permissionsArray.reduce((accu, permission) => {
    const { category, isEnabled } = permission;
    accu[category] = isEnabled;
    return accu;
  }, {});
};

const checkPrivacyPermissions = () => {
  const permissions = getPermissions();
  return (
    permissions[PRIVACY_PERMISSIONS.UGP_BEHAVIORAL_ADS] &&
    permissions[PRIVACY_PERMISSIONS.UGP_PERFORMANCE_ANALYTICS] &&
    permissions[PRIVACY_PERMISSIONS.UGP_PERSONALIZATION]
  );
};
// the query function is wrapped with async to avoid a Nike Privacy fetch failure error.
const useInitPixlee = ({ siteKey }) => {
  const hasPrivacyPermission = checkPrivacyPermissions();
  const scriptAlreadyExists = document.querySelector('script#PIXLEE_SCRIPT_ID') !== null;
  const { status, data: isPrivacyEnabled } = useQuery({
    queryKey: makeQueryKey(['privacy']),
    queryFn: async () => window?.NikePrivacy?.isInitialized(),
  });

  useEffect(() => {
    if (hasPrivacyPermission && status === 'success' && isPrivacyEnabled && !scriptAlreadyExists) {
      createScript({
        attributes: {
          id: PIXLEE_SCRIPT_ID,
          src: PIXLEE_SCRIPT_SRC,
          onload() {
            if (typeof Pixlee_Analytics !== 'undefined') {
              window.pixlee_analytics = new window.Pixlee_Analytics(PIXLEE_KEY, { siteKey });
            }
          },
        },
        embedTarget: 'body',
      });
    }
  }, [hasPrivacyPermission, isPrivacyEnabled, scriptAlreadyExists, siteKey, status]);
};

export default useInitPixlee;
